import { ReactElement, ReactNode } from 'react';

export default function getComponentType(
    child: ReactNode
): ReactElement['type'] | undefined {
    if (!child) {
        return undefined;
    }

    if (typeof child !== 'object') {
        return undefined;
    }

    if (!('type' in child)) {
        return undefined;
    }

    return child.type;
}
